var leadInitiated = false;

$(function () {


    $(document).on('focus', 'form.regForm input', function (e) {
        document.getElementById('theresults').innerHTML = "";

        if (!leadInitiated) {
            leadInitiated = true;
            dataLayer.push({event: "lead_initiated"});
        }
    });

    function validateForm($form) {
        $form = (typeof $form !== 'undefined') ? $form : $(document).find('form');

        var input, value;
        var noErrors = true;

        // Loop through each required field
        $form.find('.required,:input[required]:visible').each(function () {
            input = $(this);

            if (!$(this).prop('disabled')) {

                // Removes leading & trailing white-space
                value = input.val().replace(/^\s\s*/g, '').replace(/\s\s*$/g, '');

                // Validate non radio/checkbox fields
                if (typeof input.attr('type') === 'undefined' || (input.attr('type') !== 'undefined' && (input.attr('type') !== 'radio' && input.attr('type') !== 'checkbox'))) {
                    if (typeof value === "undefined" || value === "") {
                        input.parent().addClass('invalid');
                        noErrors = false;
                    } else {
                        input.parent().removeClass('invalid');
                    }

                    // Extra email validation
                    if ((typeof input.attr('type') !== 'undefined' && input.attr('type') === 'email') || input.hasClass('email')) {
                        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                        if (!filter.test(value)) {
                            input.parent().addClass('invalid');
                            noErrors = false;
                        } else {
                            input.parent().removeClass('invalid');
                        }
                    }

                    // Validate radio/checkbox buttons
                } else {
                    var inputName = input.attr('name');
                    if ($('input[name=' + inputName + ']:checked').length === 0) {
                        noErrors = false;
                    }
                }

            }
        });

        return noErrors;
    }


    $('form.regForm').submit(function (e) {
        e.preventDefault();

        var $form = $(this);
        if ($form.hasClass('submitting'))
            return false;

        $form.addClass('submitting');

        if (!validateForm($form)) {
            $form.find('.errors').show();
            $form.removeClass('submitting');
            $form.find('.errors').addClass('test');
        } else {
            $form.find('.errors').hide();

            let prospect = {
                comments: '',
                currentPage: '/luxury-homes-for-sale/New-Jersey/151-Bay-Street-at-Provost-Square'
            };

            // GA data for salesforce integration
            if (typeof ga !== "undefined" && typeof ga.getAll === 'function') {
                var gaTracker = ga.getAll()[0];
                var gaClientId = gaTracker.get('clientId');

                if (typeof gaClientId !== "undefined") {
                    prospect.gaClientId = gaClientId;
                }

                var gaUserId = gaTracker.get('userId');
                if (typeof gaUserId !== "undefined") {
                    prospect.gaUserId = gaUserId;
                }

                var gaTrackId = gaTracker.get('trackingId');
                if (typeof gaTrackId !== "undefined") {
                    prospect.gaTrackId = gaTrackId;
                }
            }

            prospect.firstname = $("input[name=firstname]").val();
            prospect.lastname = $("input[name=lastname]").val();
            prospect.email = $("input[name=email]").val();
            prospect.valEmail = $("input[name=val_email]").val();
            prospect.homephone = $("input[name=homephone]").val();

            if ($("input[name=prefer_contact]").val() && $("input[name=prefer_contact]").val().length > 0) {
                prospect.comments += "\n\nPreferred Contact: " + $("input[name=prefer_contact]").val();
            }

            const agentradios = document.getElementsByName('representedByBroker');
            let repByBroker = false;
            for (var i = 0; i < agentradios.length; i++) {
                if (agentradios[i].checked) {
                    if ((agentradios[i].value) == "Yes") {
                        repByBroker = true;
                        if ($("input[name=brokers_name]").val().length == 0) {
                            document.getElementById('theresults').innerHTML = "<p>Please enter your Real Estate Agent's Name</p>";
                            return false;
                        } else {
                            prospect.comments += "\n\nRepresented by Broker: Yes";
                            prospect.comments += "\nBroker's Name: " + $("input[name=brokers_name]").val();
                            prospect.comments += "\nBroker's Agency: " + $("input[name=brokerage2]").val();
                        }
                    }
                }
            }
            if (!repByBroker) {
                prospect.comments += "\n\nRepresented by Broker: No";
            }


            const radios = document.getElementsByName('agent');
            for (var i = 0; i < radios.length; i++) {
                if (radios[i].checked) {
                    if ((radios[i].value) == "Yes") {
                        prospect.agent = "yes";

                        if ($("input[name=brokerage1]").val().length == 0) {
                            document.getElementById('theresults').innerHTML = "<p>Please enter a Real Estate Agency Name</p>";
                            return false;

                        } else {
                            prospect.brokerage = $("input[name=brokerage1]").val(); // I am an agent and this is my brokerage
                        }
                    }
                }
            }

            // var priceRange = document.getElementById("priceRange");
            // var thePrice = priceRange.value;
            // var thePrice = thePrice.split('-');
            // var [price_range_min, price_range_max] = thePrice;
            // prospect.comments += "\n\nPrice Range: " + price_range_min + " - " + price_range_max;

            let roomRange = document.getElementById("roomRange");
            let theRoom = roomRange.value;
            prospect.comments += "\n\nRoom Range: " + theRoom;

//            console.log(prospect);

            let query =
                    `mutation CreateProspect($input: CreateProspectInput!, $condition: ModelProspectConditionInput) {
                createProspect(input: $input, condition: $condition) {
                    id,
                    email
                    firstname
                    lastname
                    gaClientId
                    gaUserId
                    gaTrackId
                }
            }`;
            let body = {
                query: query,
                variables: {
                    input: prospect
                }
            };

            $.ajax({
                type: "GET",
                url: "/50047dea-f969-11ed-be56-0342ac120003",
                success: function (data) {
                    $.ajax({
                        type: "POST",
                        headers: {
                            "X-Api-Key": data.key,
                            "Accept": "application/json",
                        },
                        url: data.endpoint,
                        data: JSON.stringify(body),
                        dataType: "json",
                        success: function (response) {
                            if (response) {
                                if (response.errors) {
                                    // problem
                                    let foundErrorPhone = false;
                                    for (let j = 0; j < response.errors.length; j++) {
                                        if (response.errors[j].message && response.errors[j].message.includes("homephone")) {
                                            foundErrorPhone = true;
                                            $form.find('.errors').show();
                                            $form.removeClass('submitting');
                                            $form.find('.errors').addClass('test');
                                            $("#homephone").addClass('invalid');
                                            alert("Problem with phone format");
                                        }
                                    }
                                    if (!foundErrorPhone) {
                                        $form.find('.errors').show();
                                        $form.removeClass('submitting');
                                        $form.find('.errors').addClass('test');
                                        alert(JSON.stringify(response.errors));
                                    }

                                } else if (response.data) {
                                    let redirectString = '/thank-you?email='
                                            + encodeURIComponent(response.data.createProspect.email)
                                            + '&pd='
                                            + encodeURIComponent("https://hello.tollbrothers.com/l/402642/2022-05-18/298plhn"
                                                    + "?osc-region=" + encodeURIComponent("NYC City Living")
                                                    + "&lname=" + encodeURIComponent(response.data.createProspect.lastname)
                                                    + "&gaClientId=" + encodeURIComponent(response.data.createProspect.gaClientId)
                                                    + "&gaUserId=" + encodeURIComponent(response.data.createProspect.gaUserId)
                                                    + "&gaTrackId=" + encodeURIComponent(response.data.createProspect.gaTrackId)
                                                    + "&fname=" + encodeURIComponent(response.data.createProspect.firstname)
                                                    + "&email=" + encodeURIComponent(response.data.createProspect.email));
//                                    console.log("SUCCESS = redirectString");
//                                    console.log(redirectString);
                                    location.href = redirectString;
                                }
                            }
                        },
                        error: function (errMsg) {
                            console.log("error 2", errMsg);
                            alert(errMsg);
                        }
                    });
                },
                error: function (error) {
                    console.log("error 1", error);
                    alert(error);
                }
            });
            
            return false;

        }

    }); // end of submit    


});

